import React from "react";

/**
 * ParticipantStatusCard
 * 회의 참석자 표시 카드 (재사용 가능)
 * - 주문(순번) 배지 제거
 * - 서명 이미지(sign_file) 표시 제거
 * - 상태 박스는 점선 테두리 그대로 유지
 * - 라벨 규칙
 *   - 응답 && 참석:  "응답(참여)" + ✓
 *   - 응답 && 불참:  "불참"       + ✗
 *   - 미응답:        "미응답"     + /
 */
export default function ParticipantStatusCard({
  name,
  position,
  responded,
  isAttending,
  className = "",
}) {
  const state = !responded ? "noresponse" : isAttending ? "attend" : "absent";

  const ui = {
    attend: {
      symbol: "✓",
      label: "응답(참여)",
      colorText: "text-green-600",
      colorBox: "border-green-200 bg-green-50",
    },
    absent: {
      symbol: "✗",
      label: "불참",
      colorText: "text-red-600",
      colorBox: "border-red-200 bg-red-50",
    },
    noresponse: {
      symbol: "/",
      label: "미응답",
      colorText: "text-gray-400",
      colorBox: "border-gray-200 bg-gray-50",
    },
  }[state];

  return (
    <div
      className={
        "flex flex-col items-center space-y-2 p-2 border border-slate-200 rounded-md min-w-[92px] bg-white shadow-sm " +
        className
      }
    >
      {/* 이름/직책 */}
      <div className="text-center">
        <div
          className="font-medium text-xs text-gray-800 truncate max-w-[120px]"
          title={name}
        >
          {name || "-"}
        </div>
        {position ? (
          <div
            className="text-[11px] text-gray-500 truncate max-w-[120px]"
            title={position}
          >
            {position}
          </div>
        ) : (
          <div className="text-[11px] text-gray-400">역할 없음</div>
        )}
      </div>

      {/* 상태 박스 (이미지 제거, 라벨/기호만) */}
      <div
        className={
          "w-16 h-14 border border-dashed rounded-md flex items-center justify-center " +
          ui.colorBox
        }
      >
        <div className="text-center leading-4">
          <div className={"text-lg " + ui.colorText}>{ui.symbol}</div>
          <div className={"text-[11px] " + ui.colorText}>{ui.label}</div>
        </div>
      </div>
    </div>
  );
}
